import { render } from "./TheContribute.vue?vue&type=template&id=ddaebb16"
import script from "./TheContribute.vue?vue&type=script&lang=js"
export * from "./TheContribute.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__